import http from "../request/index";

export default {
  async getLiveDetail(params) {
    return await http.get("/api/live/index", params);
  },
  async getLiveChatlist(params) {
    return await http.get("/api/live/chatlist", params);
  },
  async LiveSubmit(params) {
    return await http.post("/api/live/submit", params);
  },
  async getLike(params) {
    return await http.post("/api/live/like", params);
  },
  async getList(params) {
    return await http.post("/api/live/list", params);
  },
};
